























































import {News} from '@/models/dashboard';
import {typedStore, Actions} from '@/store';
import moment from 'moment';
import Vue from 'vue';
import VueGallery from 'vue-gallery';

export default Vue.extend({
  name: 'News',
  components: {
    gallery: VueGallery,
  },
  data() {
    return {
      images: [] as string[],
      lastFoundImageUrl: '',
      index: null as unknown as number,
      loader: {
        isNewsListPending: false,
      },
    };
  },
  async created() {
    this.loader.isNewsListPending = true;
    try {
      await this.$store.dispatch(Actions.news.fetchNews);
      this.updateGallery();
      this.updateNewsContent();
    } finally {
      this.loader.isNewsListPending = false;
    }
  },
  computed: {
    newsList(): News[] {
      return typedStore(this).state.news.newsList;
    },
    areMoreItemsAvailable(): boolean {
      return this.newsList.length < typedStore(this).state.news.pagination.totalCount && this.newsList.length > 0;
    },
  },
  methods: {
    updateNewsContent(): void {
      for (const newsItem of this.newsList) {
        const regex = /@\w+.\w+/g;
        const found = newsItem.content.match(regex);
        found?.forEach(geekEmail => {
          const geek = newsItem.geeks.find(g => geekEmail.substr(1) === g.firstName + '.' + g.lastName);

          if (geek) {
            const htmlElement = `<a class="geek-profile-link" href="/geek-profile/${geek?.id}" target="_self">
                <div class="d-inline-flex pb-2">
                      <img
                          src="${geek?.avatarUrl}"
                          class="geek-default-avatar small" />
                      <div class="geek-profile">
                            <span class="geek-name-color">
                            ${geek?.firstName}
                            ${geek?.lastName}
                          </span>
                      </div>
                    </div></a>`;
            newsItem.content = newsItem.content.replace(geekEmail, htmlElement);
          }
        });
      }
    },

    getNewsTime(dateTime: string): string {
      return moment.duration(moment().diff(moment(dateTime))).asDays() <= 3
        ? moment(dateTime).fromNow()
        : (this as any).$options.filters.formattedDate(dateTime);
    },
    updateGallery() {
      const allImages = Array.from(document.querySelectorAll('.news-content img')) as HTMLImageElement[];
      const imageUrls = allImages.map(img => img.src);
      const lastFoundImageIndex = imageUrls.findIndex(img => img === this.lastFoundImageUrl);
      allImages.forEach((img, index: number) => {
        if (lastFoundImageIndex && index <= lastFoundImageIndex) {
          return;
        }

        this.images.push(img.src);
        img.addEventListener('click', () => this.index = index);
      });
      this.lastFoundImageUrl = this.images[this.images.length - 1];
    },
    async loadMoreElements() {
      this.loader.isNewsListPending = true;
      try {
        await this.$store.dispatch(Actions.news.fetchMoreNews);
        this.updateGallery();
        this.updateNewsContent();
      } finally {
        this.loader.isNewsListPending = false;
      }
    },
  },
});
